import { z } from "zod";

const profileSchema = z.object({
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  middle_name: z.string().nullable(),
  avatar_url: z.string().nullable(),
});

const lastActivitySchema = z.object({
  last_action_at: z.string().nullable(),
  last_action_type: z.string().nullable(),
  last_ip: z.string().nullable(),
  last_user_agent: z.string().nullable(),
  last_device_id: z.string().nullable(),
  last_country: z.string().nullable(),
});

const oauthProviderSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
  provider: z.string(),
  provider_user_id: z.string(),
  username: z.string().nullable(),
  display_name: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  gender: z.string().nullable(),
  full_name: z.string().nullable(),
  email: z.string().nullable(),
  phone_number: z.string().nullable(),
  birthdate: z.string().nullable(),
  avatar_missing: z.boolean(),
  avatar_id: z.string().nullable(),
});

export const clientSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
  deleted_at: z.string().nullable(),
  public_login: z.string().nullable(),
  email: z.string().nullable(),
  phone_number: z.string().nullable(),
  locked_until: z.string().nullable(),
  blocked_at: z.string().nullable(),
  block_reason: z.string().nullable(),
  blocked_by: z.number().nullable(),
  delete_reason: z.string().nullable(),
  deleted_by: z.number().nullable(),
  contact_source: z.string().nullable().optional(),
  profile: profileSchema.nullable(),
  last_activity: lastActivitySchema.nullable(),
  oauth_providers: z.array(oauthProviderSchema).nullable().optional(),
});

export type AuthClient = z.infer<typeof clientSchema>;

export const blockClientSchema = z.object({
  reason: z.string().min(1, "Укажите причину блокировки"),
});

export type BlockClientForm = z.infer<typeof blockClientSchema>;

export const deleteClientSchema = z.object({
  reason: z.string().min(1, "Укажите причину удаления"),
});

export type DeleteClientForm = z.infer<typeof deleteClientSchema>;

export interface ClientStats {
  total: number;
  active: number;
  blocked: number;
  deleted: number;
  today: number;
  week: number;
  month: number;
}

export interface ClientFilter {
  query: string;
  status: string;
  page: number;
  limit: number;
  sort_by: string;
  sort_order: "asc" | "desc";
}

export interface PageResponse {
  clients: AuthClient[];
  total: number;
  page: number;
  limit: number;
}
